import { render } from "./Phrases.vue?vue&type=template&id=3f7365d3"
import script from "./Phrases.vue?vue&type=script&lang=js"
export * from "./Phrases.vue?vue&type=script&lang=js"

import exportComponent from "/home/srodino/Tests/drinkif/frontend/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__